import { Injectable } from '@angular/core'
import { TmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService, TransformationService } from 'common-services'

export interface IClaimLineX12 extends IModelBase {
  LeftEdiFileRevisionId: number
  Left: string
  LeftDate: Date
  RightEdiFileRevisionId: number
  Right: string
  RightDate: Date
}

@Injectable()
export class ClaimLineX12TransformationService extends TransformationService<IClaimLineX12> {
  constructor() {
    super()
  }

  responseTransformArray(response: any, method: string): IClaimLineX12[] {
    response = [].concat(response)
    response = response.map(x => {
      x.Id = '1'
      return x
    })
    return response
  }
}

@Injectable()
export class ClaimLineX12ODataService extends ODataService<IClaimLineX12> {
  constructor(
    protected http: HttpClient,
    protected config: TmODataConfiguration,
    protected idTransformService: ClaimLineX12TransformationService
  ) {
    super(http, config, idTransformService)
    this.typeName = 'EdiComparisonView'
  }
}
